import constants from "constants/constants";

export const DEFAULT_ACCESSIBILITY_VAL = "1";

export const SHARE_RECORDING_FORM_KEYS = {
  MAP_TO_COURSE: "map_to_course",
  IS_AUTO_RECORDABLE: "is_auto_recordable",
  RECORDING_ACCESSIBILITY: "recording_accessibility",
};

export const course_availability_options = [
  {
    label: "All the recordings",
    value: "1",
    tooltipText:
      "All recordings will be shared with the customer, regardless of when they book, how many sessions have passed by, or how many sessions they have attended.",
  },
  {
    label: "Only recordings held after booking",
    value: "2",
    tooltipText:
      "Only those recordings will be shared with the customer, that have occurred after the customer booked.",
  },
];

export const access_visibility_address_type = [
  constants.address_type_enum.zoom,
  constants.address_type_enum.exly_connect_by_zoom,
];

export const SHARE_RECORDING_TEXTS = {
  FUTURE_RECORDINGS_BANNER:
    "Only future recorded sessions will be mapped or auto-packaged. Existing recordings will remain untouched.",
  SESSION_RECORDING_TITLE: "Session recording",
  SESSION_RECORDING_DESC:
    "Turn this off to stop recording every future session on this offering. Sessions already recorded are not affected.",
  AUTO_PACKAGE_TITLE: "Auto-package recordings into a course",
  AUTO_PACKAGE_DESC:
    'When on, each recorded session is automatically added as a lesson to a course, so learners can watch it without you mapping it by hand. Turn this off to keep recordings in "Unmapped recordings" for manual mapping instead.',
  SHARE_WITH_CUSTOMERS_TITLE: "Share recording with customers",
  SHARE_WITH_CUSTOMERS_DESC:
    "This feature enables you to share the zoom recording(s) of your session(s) with your customers. You can further select the accessibility of those recordings as well.",
  CUSTOMER_ACCESS_QUESTION:
    "Which recording(s) should be made available to customers?",
  FAQ_PROMPT: "Want to know how are recordings collected and shared?",
  FAQ_LINK: "Click here to learn more",
  UPGRADE_TITLE: "Upgrade plan to ‘Premium’ to unlock!",
};

export const SHARE_RECORDING_DISPLAY_NAME = "ShareRecording";
